<template>
  <div class="creative-page">

    <section class="heroSection" :class="{ 'creative-hero--en': !isAr }">
      <b-container fluid class="px-0">
        <b-row
          no-gutters
          class="creative-hero-split intro-section align-items-stretch mx-0"
          :class="{ 'flex-xl-row-reverse': isAr }"
        >
          <b-col
            cols="12"
            xl="6"
            class="creative-hero-copy d-flex align-items-center py-5 px-4 px-xl-5"
          >
            <div class="creative-hero-text w-100">
              <h1 class="mb-3"><b>{{ langDec.creative_hero_title }}</b></h1>
              <p class="mb-0">{{ langDec.creative_hero_subtitle }}</p>
            </div>
          </b-col>
          <b-col cols="12" xl="6" class="creative-hero-art p-0" aria-hidden="true" />
        </b-row>
      </b-container>
    </section>

    <section class="creative-gallery-section">
      <b-container fluid class="creative-gallery-container">
        <div v-if="pageIsLoading && items.length === 0" class="creative-loading text-center py-5">
          <b-spinner variant="primary" class="align-middle"></b-spinner>
          <p class="mt-3 mb-0 text-muted">{{ langDec.creative_loading }}</p>
        </div>

        <div v-else-if="items.length === 0" class="text-center py-5 text-muted">
          {{ langDec.creative_empty }}
        </div>

        <div v-else class="creative-masonry">
          <button
            v-for="(img, idx) in items"
            :key="photoKey(img, idx)"
            type="button"
            class="creative-cell"
            :aria-label="langDec.creative_zoom_aria + ': ' + photoLabel(img)"
            @click="openLightbox(idx)"
          >
            <span class="creative-cell__media">
              <img
                class="creative-cell__img"
                :src="photoSrc(img)"
                :alt="photoLabel(img)"
                loading="lazy"
              >
            </span>
            <span class="creative-cell__pill">{{ photoLabel(img) }}</span>
          </button>
        </div>

        <div v-if="items.length > 0 && hasMore" class="text-center mt-4 mb-2">
          <b-button
            variant="outline-primary"
            class="creative-load-more"
            :disabled="pageIsLoading"
            @click="loadMore"
          >
            <b-spinner v-if="pageIsLoading" small class="ml-2"></b-spinner>
            {{ langDec.creative_load_more }}
          </b-button>
        </div>
      </b-container>
    </section>

    <transition name="creative-lb-fade">
      <div
        v-if="lightboxShow"
        class="creative-lb-overlay"
        role="dialog"
        aria-modal="true"
        :aria-label="langDec.creative_lb_dialog"
        @click.self="lightboxShow = false"
      >
        <button
          type="button"
          class="creative-lb-close"
          :aria-label="langDec.creative_lb_close"
          @click="lightboxShow = false"
        >
          <svg class="creative-lb-close__svg" viewBox="0 0 24 24" aria-hidden="true">
            <path
              fill="currentColor"
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
          </svg>
        </button>

        <div class="creative-lb-shell">
          <button
            type="button"
            class="creative-lb-arrow creative-lb-arrow--prev"
            :aria-label="langDec.creative_lb_prev"
            @click.stop="lightboxPrev"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>
          </button>

          <figure v-if="lightboxCurrentItem" class="creative-lb-card">
            <div class="creative-lb-frame">
              <img
                :key="lightboxIndex"
                class="creative-lb-img"
                :src="photoSrc(lightboxCurrentItem)"
                :alt="photoLabel(lightboxCurrentItem)"
              >
            </div>
            <figcaption class="creative-lb-meta">
              <div class="creative-lb-meta__row">
                <span class="creative-lb-pill">{{ lightboxIndex + 1 }} {{ langDec.creative_lb_of }} {{ items.length }}</span>
                <h3 class="creative-lb-title">{{ photoLabel(lightboxCurrentItem) }}</h3>
              </div>
              <p v-if="lightboxDescription" class="creative-lb-desc">{{ lightboxDescription }}</p>
            </figcaption>
          </figure>

          <button
            type="button"
            class="creative-lb-arrow creative-lb-arrow--next"
            :aria-label="langDec.creative_lb_next"
            @click.stop="lightboxNext"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>
          </button>
        </div>
      </div>
    </transition>

    <section class="subscribe">
      <div>
        <div>
          <div class="">
            <div class="col-md-12 col-sm-12 col-xs-12 creative-subscribe-outer">
              <div class="py-5 my-5">
                <div class="">
                  <h2>{{ langDec.creative_subscribe_heading }}</h2>
                  <div class="description">
                    <br>
                    <p v-if="!googleplay && !applestore" style="color: red;">
                      <b>{{ langDec.articles_app_unavailable }}</b>
                      <br>
                      <b-button @click="goToRoute('contactus')" class="px-4 py-2 my-4" variant="primary">
                        <span>{{ langDec.articles_contact_us }}</span>
                      </b-button>
                    </p>
                  </div>
                  <div v-if="googleplay || applestore" class="action-btns mt-2">
                    <b-button v-if="applestore" @click="goTowebsite(applestore)" class="px-4 py-3 mx-4 my-3"
                      style="background-color: black; color:white !important; border: black !important;">
                      <div
                        class="store-badge-inner carousel-btn-in-div px-3"
                        :class="{ 'store-badge-inner--en': !isAr }"
                      >
                        <div class="store-badge-inner__icon store-badge-inner__icon--apple">
                          <img class="store-badge-inner__apple-img"
                            src="../assets/images/Apple_logo_white.svg.png" alt="">
                        </div>
                        <div class="carousel-btn-in-div-text store-badge-inner__text creative-subscribe-store-text">
                          <span>{{ langDec.nav_available_on }}</span>
                          <br>
                          <span>App Store</span>
                        </div>
                      </div>
                    </b-button>
                    <b-button v-if="googleplay" @click="goTowebsite(googleplay)" class="px-4 py-3 mx-4 my-3"
                      variant="primary" style="color:white !important;border: black !important;">
                      <div
                        class="store-badge-inner px-3"
                        :class="{ 'store-badge-inner--en': !isAr }"
                      >
                        <div class="store-badge-inner__icon store-badge-inner__icon--google">
                          <svg class="kOqhQd" aria-hidden="true" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
                            <path fill="none" d="M0,0h40v40H0V0z"></path>
                            <g>
                              <path
                                d="M19.7,19.2L4.3,35.3c0,0,0,0,0,0c0.5,1.7,2.1,3,4,3c0.8,0,1.5-0.2,2.1-0.6l0,0l17.4-9.9L19.7,19.2z"
                                fill="#EA4335"></path>
                              <path
                                d="M35.3,16.4L35.3,16.4l-7.5-4.3l-8.4,7.4l8.5,8.3l7.5-4.2c1.3-0.7,2.2-2.1,2.2-3.6C37.5,18.5,36.6,17.1,35.3,16.4z"
                                fill="#FBBC04"></path>
                              <path d="M4.3,4.7C4.2,5,4.2,5.4,4.2,5.8v28.5c0,0.4,0,0.7,0.1,1.1l16-15.7L4.3,4.7z"
                                fill="#4285F4"></path>
                              <path
                                d="M19.8,20l8-7.9L10.5,2.3C9.9,1.9,9.1,1.7,8.3,1.7c-1.9,0-3.6,1.3-4,3c0,0,0,0,0,0L19.8,20z"
                                fill="#34A853"></path>
                            </g>
                          </svg>
                        </div>
                        <div class="carousel-btn-in-div-text store-badge-inner__text creative-subscribe-store-text">
                          <span>{{ langDec.nav_available_on }}</span>
                          <br>
                          <span>Google Play</span>
                        </div>
                      </div>
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { sendRequest } from '../utils/RequestHelper.js'

export default {
  name: 'CreativePage',
  data() {
    return {
      items: [],
      totalCount: 0,
      pageNumber: 1,
      pageSize: 10,
      pageIsLoading: false,
      lastBatchFull: false,
      googleplay: process.env.VUE_APP_GOOGLEPLAYLINK,
      applestore: process.env.VUE_APP_APPLESTORELINK,
      lightboxShow: false,
      lightboxIndex: 0,
      keyListenerBound: false,
    }
  },

  computed: {
    ...mapGetters(["getLangData", "getlang"]),
    langDec() {
      return this.getLangData || {}
    },
    isAr() {
      return this.getlang === "ar"
    },
    hasMore() {
      if (this.totalCount > 0) return this.items.length < this.totalCount
      return this.lastBatchFull
    },
    lightboxCurrentItem() {
      return this.items[this.lightboxIndex] || null
    },
    lightboxDescription() {
      const it = this.lightboxCurrentItem
      if (!it) return ''
      const d = it.description ?? it.Description ?? ''
      return String(d).trim()
    },
  },

  watch: {
    lightboxShow(on) {
      document.body.style.overflow = on ? 'hidden' : ''
      if (on) {
        this.bindKeys()
      } else {
        this.unbindKeys()
      }
    },
  },

  methods: {
    photoKey(img, idx) {
      return img.id ?? img.photoId ?? idx
    },
    photoSrc(item) {
      if (!item) return ''
      const raw =
        item.mediaUrl ||
        item.MediaUrl ||
        item.imageUrl ||
        item.ImageUrl ||
        item.url ||
        item.fileUrl ||
        ''
      if (!raw) return ''
      if (/^https?:\/\//i.test(String(raw))) return String(raw).trim()
      const base = (process.env.VUE_APP_API_URL_IMAGE || '').replace(/\/?$/, '')
      const path = String(raw).replace(/^\//, '')
      return `${base}/${path}`
    },
    photoLabel(item) {
      const fallback = (this.getLangData && this.getLangData.creative_default_label) || 'Creative'
      if (!item) return fallback
      return (
        item.title ||
        item.Title ||
        item.categoryName ||
        item.photoCategoryName ||
        item.typeName ||
        (item.category && (item.category.name || item.category.title)) ||
        fallback
      )
    },
    goTowebsite(link) {
      window.open(link, "_blank")
    },
    goToRoute(name) {
      this.$router.push({ name }).catch(() => {})
    },
    loadData(append) {
      if (!append) {
        this.pageNumber = 1
      }
      this.pageIsLoading = true
      const body = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      }
      sendRequest(
        'post',
        'Photo/search',
        true,
        body,
        (response) => {
          const payload = response.data && response.data.data !== undefined ? response.data.data : response.data
          const rawItems = (payload && payload.items) || []
          const tc = payload && payload.totalCount
          if (typeof tc === 'number') {
            this.totalCount = tc
          }
          this.lastBatchFull = rawItems.length >= this.pageSize
          if (append) {
            this.items = [...this.items, ...rawItems]
          } else {
            this.items = rawItems
          }
          this.pageIsLoading = false
        },
        () => {
          this.pageIsLoading = false
          if (append) {
            this.pageNumber = Math.max(1, this.pageNumber - 1)
          } else {
            this.items = []
          }
        }
      )
    },
    loadMore() {
      if (!this.hasMore || this.pageIsLoading) return
      this.pageNumber += 1
      this.loadData(true)
    },
    openLightbox(idx) {
      this.lightboxIndex = idx
      this.lightboxShow = true
    },
    lightboxPrev() {
      if (!this.items.length) return
      this.lightboxIndex =
        this.lightboxIndex <= 0 ? this.items.length - 1 : this.lightboxIndex - 1
    },
    lightboxNext() {
      if (!this.items.length) return
      this.lightboxIndex =
        this.lightboxIndex >= this.items.length - 1 ? 0 : this.lightboxIndex + 1
    },
    onGlobalKeydown(e) {
      if (!this.lightboxShow) return
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault()
        if (e.key === 'ArrowRight') this.lightboxNext()
        else this.lightboxPrev()
      }
      if (e.key === 'Escape') {
        this.lightboxShow = false
      }
    },
    bindKeys() {
      if (this.keyListenerBound) return
      window.addEventListener('keydown', this.onGlobalKeydown)
      this.keyListenerBound = true
    },
    unbindKeys() {
      if (!this.keyListenerBound) return
      window.removeEventListener('keydown', this.onGlobalKeydown)
      this.keyListenerBound = false
    },
  },

  created() {
    this.loadData(false)
  },

  beforeDestroy() {
    this.unbindKeys()
    document.body.style.overflow = ''
  },
}
</script>

<style scoped>
.subscribe {
  background-color: #f5f5f5;
}

/* Split hero — copy column solid green; art column shows vector (no overlap) */
.heroSection .creative-hero-split {
  min-height: 450px;
}

.creative-hero-art {
  min-height: 280px;
  background-color: #0d7a45;
  background-image: url(../assets/images/creativeBG.png);
  background-size: cover;
  background-repeat: no-repeat;
  /* Figure sits on the left of the asset — same anchor AR + EN (right anchor clipped in RTL column). */
  background-position: left center;
}

/* Arabic: show full illustration inside the art column (cover was cropping the figure). */
.heroSection:not(.creative-hero--en) .creative-hero-art {
  background-size: contain;
  background-position: center center;
}

.creative-hero-copy {
  background: linear-gradient(160deg, #054d2a 0%, #006633 42%, #0a7a44 100%);
  color: #fff;
}

.creative-hero-text {
  text-align: start;
}

.creative-hero-text h1 {
  font-size: 2.25rem !important;
  font-weight: bolder !important;
  line-height: 1.2;
  color: #fff !important;
}

.creative-hero-text p {
  font-size: 1.125rem;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.96) !important;
}

@media (min-width: 1200px) {
  .creative-hero-art {
    min-height: 450px;
  }

  .creative-hero-text h1 {
    font-size: 2.5rem !important;
  }

  .creative-hero-text p {
    font-size: 1.2rem;
  }
}

@media (max-width: 991.98px) {
  .heroSection .creative-hero-split {
    min-height: 0;
  }

  .creative-hero-art {
    min-height: 260px;
  }
}

@media (max-width: 767.98px) {
  .creative-hero-art {
    min-height: 220px;
  }
}

.creative-subscribe-outer {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.store-badge-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  direction: ltr;
  gap: 0.875rem;
}

.store-badge-inner--en {
  flex-direction: row-reverse;
}

.store-badge-inner__icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.store-badge-inner__icon--apple {
  width: 35px;
  height: 35px;
  color: #fff;
}

.store-badge-inner__icon--google {
  width: 40px;
  height: 40px;
}

.store-badge-inner__apple-img {
  width: 35px;
  height: auto;
  margin-top: -3px;
  display: block;
}

.creative-subscribe-store-text {
  font-size: 14px;
  line-height: 1.25;
  text-align: start;
}

.creative-gallery-section {
  background: #fff;
  padding: 48px 0 56px;
}

.creative-gallery-container {
  max-width: 1140px;
  padding-left: 24px;
  padding-right: 24px;
}

.creative-masonry {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
  align-items: stretch;
}

.creative-cell {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0;
  border: none;
  background: transparent;
  cursor: zoom-in;
  border-radius: 14px;
  overflow: hidden;
  text-align: start;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.creative-cell:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 102, 51, 0.35);
}

.creative-cell:hover {
  transform: translateY(-4px);
  box-shadow: 0 14px 32px rgba(0, 102, 51, 0.14);
}

.creative-cell__media {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  background: linear-gradient(145deg, #eef1f3 0%, #e2e6ea 100%);
  overflow: hidden;
}

.creative-cell__img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}

.creative-cell__pill {
  position: absolute;
  bottom: 12px;
  inset-inline-start: 12px;
  padding: 6px 14px;
  font-size: 0.78rem;
  font-weight: 600;
  color: #fff;
  background: rgba(33, 37, 41, 0.72);
  border-radius: 999px;
  backdrop-filter: blur(6px);
  max-width: calc(100% - 24px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  pointer-events: none;
}

@media (max-width: 991.98px) {
  .creative-masonry {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
  }
}

@media (max-width: 767.98px) {
  .creative-gallery-container {
    padding-left: 16px;
    padding-right: 16px;
  }

  .creative-hero-text h1 {
    font-size: 1.75rem !important;
  }
}

@media (max-width: 575.98px) {
  .creative-masonry {
    grid-template-columns: minmax(0, 1fr);
    gap: 14px;
  }
}

.creative-load-more {
  border-radius: 10px;
  font-weight: 600;
  padding-left: 1.75rem;
  padding-right: 1.75rem;
  border-color: #006633 !important;
  color: #006633 !important;
}

.creative-load-more:hover {
  background: #006633 !important;
  color: #fff !important;
}

/* ——— Lightbox (custom overlay — بدون b-modal لتجنب مشاكل الموضع) ——— */
.creative-lb-fade-enter-active,
.creative-lb-fade-leave-active {
  transition: opacity 0.32s ease;
}

.creative-lb-fade-enter,
.creative-lb-fade-leave-to {
  opacity: 0;
}

.creative-lb-overlay {
  position: fixed;
  inset: 0;
  z-index: 1080;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(16px, 4vw, 40px);
  background: rgba(5, 14, 11, 0.78);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
}

.creative-lb-close {
  position: fixed;
  top: clamp(14px, 3vh, 28px);
  inset-inline-start: clamp(14px, 3vw, 28px);
  z-index: 1090;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.22);
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.35);
  transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}

.creative-lb-close:hover {
  background: rgba(0, 102, 51, 0.85);
  border-color: rgba(255, 255, 255, 0.35);
  transform: scale(1.06);
}

.creative-lb-close__svg {
  display: block;
  width: 22px;
  height: 22px;
}

.creative-lb-shell {
  position: relative;
  width: min(94vw, 1240px);
  margin-inline: auto;
  padding-inline: clamp(44px, 5vw, 64px);
}

.creative-lb-card {
  margin: 0;
  width: 100%;
  max-width: 100%;
  border-radius: 20px;
  overflow: hidden;
  background: linear-gradient(
    165deg,
    rgba(255, 255, 255, 0.09) 0%,
    rgba(255, 255, 255, 0.03) 50%,
    rgba(0, 102, 51, 0.06) 100%
  );
  border: 1px solid rgba(255, 255, 255, 0.14);
  box-shadow:
    0 28px 90px rgba(0, 0, 0, 0.55),
    0 0 0 1px rgba(0, 102, 51, 0.15) inset;
}

.creative-lb-frame {
  padding: clamp(10px, 1.5vw, 16px);
  padding-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: min(52vh, 420px);
}

.creative-lb-img {
  max-width: 100%;
  width: auto;
  height: auto;
  max-height: min(78vh, 920px);
  object-fit: contain;
  border-radius: 14px;
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.35);
  animation: creative-lb-img-in 0.38s ease;
}

@keyframes creative-lb-img-in {
  from {
    opacity: 0;
    transform: scale(0.97);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.creative-lb-arrow {
  position: absolute;
  top: 38%;
  transform: translateY(-50%);
  z-index: 3;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.22);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
  transition: background 0.2s ease, transform 0.2s ease, border-color 0.2s ease;
}

.creative-lb-arrow svg {
  width: 26px;
  height: 26px;
}

.creative-lb-arrow:hover {
  background: rgba(0, 102, 51, 0.92);
  border-color: rgba(255, 255, 255, 0.35);
  transform: translateY(-50%) scale(1.08);
}

.creative-lb-arrow--prev {
  inset-inline-start: 0;
}

.creative-lb-arrow--next {
  inset-inline-end: 0;
}

.creative-lb-meta {
  padding: clamp(14px, 2vw, 20px) clamp(16px, 2.5vw, 24px) clamp(18px, 2.5vw, 22px);
  text-align: center;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.22);
}

.creative-lb-meta__row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.creative-lb-pill {
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #fff;
  background: linear-gradient(135deg, #006633 0%, #0a5530 100%);
  border-radius: 999px;
  box-shadow: 0 4px 14px rgba(0, 102, 51, 0.45);
}

.creative-lb-title {
  margin: 0;
  font-size: clamp(1.05rem, 2.5vw, 1.35rem);
  font-weight: 700;
  color: #fff;
  line-height: 1.4;
  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.35);
}

.creative-lb-desc {
  margin: 12px 0 0;
  font-size: 0.92rem;
  line-height: 1.75;
  color: rgba(255, 255, 255, 0.78);
  max-width: 720px;
  margin-inline: auto;
}

@media (max-width: 575.98px) {
  .creative-lb-shell {
    padding-inline: 40px;
  }

  .creative-lb-arrow {
    width: 42px;
    height: 42px;
    top: 32%;
  }

  .creative-lb-arrow svg {
    width: 22px;
    height: 22px;
  }

  .creative-lb-img {
    max-height: min(68vh, 640px);
  }

  .creative-lb-meta__row {
    flex-direction: column;
    gap: 8px;
  }
}

</style>
